import { Button, Modal } from "reactstrap";
import { useState } from "react";
import { modalCrossIcon } from "../../../Shared/SVGs/Shared";
import { useSelector } from "react-redux";

const FormStepsModal = ({ step, content, style }) => {
  const lastStepShownKey = "campaignModals";
  const lastStepShown = parseInt(localStorage.getItem(lastStepShownKey), 10);
  const [open, setOpen] = useState(
    lastStepShown < step || isNaN(lastStepShown)
  );
  const [secondModalOpen, setSecondModalOpen] = useState(false);

  const toggle = () => {
    setOpen(!open);
    if (open && (lastStepShown < step || isNaN(lastStepShown))) {
      localStorage.setItem(lastStepShownKey, step.toString());
    }
  };

  const handleNextClick = () => {
    setSecondModalOpen(true);
    window.scrollTo(0, 300);
  };
  const showCampaignStep = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignStep
  );

  return (
    <>
      <Modal
        backdropClassName="back-drop"
        isOpen={open}
        toggle={toggle}
        contentClassName="custom-modals"
        style={style}
      >
        <div
          className={`custom-modal-arrow ${step === 5 ? "right" : ""}`}
          style={{ top: showCampaignStep && "33%" }}
        ></div>
        <div className="cross">
          {!showCampaignStep && (
            <>
              <div className="step-count ms-4">{step} of 5</div>
              <div onClick={toggle}>{modalCrossIcon}</div>
            </>
          )}
        {showCampaignStep && <div onClick={toggle} className="ms-auto">{modalCrossIcon}</div>}
        </div>
        {!showCampaignStep && <p className="step ms-4">Step {step}</p>}
        <div className="modal-text ms-4">{content}</div>
        {step === 3 && (
          <div className="d-flex justify-content-center mt-2 mb-3">
            <Button
              style={{
                width: "85px",
                height: "35px",
              }}
              size="sm"
              color="primary"
              onClick={() => {
                handleNextClick();
                toggle();
              }}
            >
              Next
            </Button>
          </div>
        )}
      </Modal>

      {step === 3 && (
        <Modal
          backdropClassName="back-drop"
          isOpen={secondModalOpen}
          toggle={() => setSecondModalOpen(false)}
          contentClassName="custom-modals"
          style={{
            position: "relative",
            top: "480px",
            left: "180px",
          }}
        >
          <div
            className="custom-modal-arrow"
            style={{
              top: "18%",
            }}
          ></div>
          <div className="cross">
            <div className="step-count ms-4">{step} of 5</div>
            <div onClick={() => setSecondModalOpen(false)}>
              {modalCrossIcon}
            </div>
          </div>
          <p className="step ms-4">Step {step}</p>
          <div className="modal-text ms-4 mb-3">
            Please review the Terms & Conditions before completing your campaign
            setup. You have the option to utilize the{" "}
            <b>default Vyrill Terms & Conditions</b> or customize your own.
          </div>
        </Modal>
      )}
    </>
  );
};

export default FormStepsModal;
